import {
  faEye,
  faEyeDropper,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function EyeButton({ onClick }) {
  return (
    <button
      aria-label="상세 보기"
      style={{
        marginLeft: 8,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "transparent",
        cursor: "pointer",
        border: "1px solid #ddd",
        borderRadius: "50%",
        width: 20,
        height: 20,
      }}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faEye} style={{ width: 12, height: 12 }} />
    </button>
  );
}

export default EyeButton;
